import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AccordionConfig } from "ngx-bootstrap/accordion";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { Subject, Subscription } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { UtilService } from "src/app/services/util.service";
import { CommonValues } from '../../../services/commonValues';
import { SearchData } from '../../../services/searchData';

/** Business menu pages: switching tabs (or re-clicking the active one) always
 *  resets the page to the very top, unconditionally — no partial/"freeze point"
 *  scroll math, which was landing short depending on the page's current scroll
 *  position and content height. Shared by BusinessComponent (menu page change)
 *  and menuclick (re-click) so the behaviour is identical everywhere. */
export function scrollBusinessToFreezePoint(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

/** Re-clicking the active business tab: BusinessComponent listens and remounts
 *  its router-outlet so the tab reloads its data (the router ignores a
 *  same-URL navigation). */
export const businessTabReload$ = new Subject<void>();

export function getAccordionConfig(): AccordionConfig {
  return Object.assign(new AccordionConfig(), { closeOthers: true });
}

@Component({
  selector: "app-navigation-header",
  standalone: true,
  imports: [BsDropdownModule,
    CommonModule,
    RouterModule
  ],
  templateUrl: "./navigation-header.component.html",
  styleUrls: ["./navigation-header.component.scss"],
  providers: [{ provide: AccordionConfig, useFactory: getAccordionConfig }],
  inputs: ["Menu"],
  outputs: ['widgetTrigger']
})
export class NavigationHeaderComponent implements OnInit, OnDestroy {
  @ViewChild("businessmenusticky") menuElement: ElementRef;
  @Input() DeactivateMenu: string;
  widgetTrigger = new EventEmitter();
  Menu: "pageadmin" | null = null;
  businessmenustick: boolean = false;

  // clickEventsubscription: Subscription; //
  employeeCount: Subscription;
  followerRequesCount: Subscription;

  commondata: any = {};
  active;
  // commondata

  allroles: any = [];
  selectedRole = "13";
  selectedDetails: any = [];
  screenData: any = [];
  serviceData: any = [];
  roleData: any = [];
  rolescreenMap = {};
  groupedMenu = [];
  panelOpenState = false;
  // isSuperAdmin: any;
  employeeRequestFlag: boolean = true;
  followerRequestFlag: boolean = true;
  managePageFlag: boolean = true
  values: any = {};
  navigationMenu = [];
  navigationadminMenu = [];
  selectedItem;
  submenuData;
  reqPendinCnt;
  visitorsCnt;
  // businessId :string;
  businessData: any;
  constructor(
    private commonvalues: CommonValues,
    private searchData: SearchData,
    private api: ApiService,
    private util: UtilService,
    private _activated_route: ActivatedRoute,
    private router: Router
  ) {

    // this.clickEventsubscription = this.commonvalues
    //   .getbusinessid()
    //   .subscribe((res) => {

    //     this.commondata = res;
    //  if(res.isFollow){
    //     //   this.isAFollower = 'true'
    //     // }
    //     // else if(!res.isFollow){
    //     //   this.isAFollower = 'false';
    //     // }
    //     // if(res.menu == "requestsReceived"){
    //     //   this.employeeRequestFlag = false
    // }
    // });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        // Open (never close) the section that owns the page we just landed on,
        // so a direct link to Manage Employees / Invites Sent shows its parent
        // expanded. Closing is left to the user via the arrow.
        this.openSectionForUrl(event.url);
      }
    });

    this._activated_route.queryParams.subscribe(ele => {
      this.businessData = ele;
      // this.businessId =  ele.businessId;


      if (ele.menu === "admin") {
        this.commondata.menu = "admin";
        this.managePageFlag = false;
        this.menuclick('admin')
      }
      if(ele.menu=== 'pageadmin') {
        this.managePageFlag = false;
      }
    });

    this.followerRequesCount = this.searchData
      .getVisitorsCount()
      .subscribe((res) => {
        this.visitorsCnt = res;
      });
  }
  ngOnDestroy(): void {
    this.Menu = null;
  }

  // Exact path-segment match, so 'employee' doesn't match 'employee-requests'.
  isPathActive(target: string): boolean {
    const path = (this.currentRoute || '').split('?')[0];
    return path === target || path.startsWith(target + '/');
  }

  get isAdminView(): boolean {
    return (this.businessData?.isSuperAdmin == 'true' || this.businessData?.isAdmin == 'true')
      && this.businessData?.viewingAsMember != 'true';
  }

  get isSuperAdminView(): boolean {
    return this.businessData?.isSuperAdmin == 'true' && this.businessData?.viewingAsMember != 'true';
  }

  isActive(route: string): boolean {
    return this.currentRoute === route;
  }

  isChildActive(parentRoute: string): boolean {
     return this.currentRoute.startsWith(parentRoute);
  }


  // Expand the parent section of a sub-page URL. Only ever opens; it never forces a
  // section closed, otherwise navigating via the label would undo an arrow click.
  openSectionForUrl(url: string) {
    if((this.businessData?.isSuperAdmin == 'true' || this.businessData?.isAdmin=='true') && this.businessData?.viewingAsMember!='true'){
      if (url.includes('/business/employee-requests')) {
        this.employeeRequestFlag = false;
      }
      if (url.includes('/business/followerRequest-sent')) {
        this.followerRequestFlag = false;
      }
    }
  }

  // Arrow click: flip the section open/closed and nothing else. stopPropagation
  // keeps the click from reaching any ancestor handler.
  toggleSubMenu(flag: 'employeeRequestFlag' | 'followerRequestFlag', event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this[flag] = !this[flag];
  }


  // isAFollower: any;
  ngOnInit() {
    this.currentRoute = this.router.url;
    // this.isAFollower = localStorage.getItem('isAFollower')
    // this.isSuperAdmin = localStorage.getItem("isSuperAdmin");

    this.apicall();
  }

  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;

    if (windowScroll >= 327.5) {
      this.businessmenustick = true;
    } else {
      this.businessmenustick = false;
    }
  }

  // displaymenu(){

  //      var screen =  localStorage.getItem('screen')

  //      var adminviewflag= localStorage.getItem('adminviewflag')
  //      this.navidationData.forEach(element => {

  //       if( element.page==screen){
  //         if(adminviewflag!=undefined||adminviewflag!=null||adminviewflag!=''){
  //          if(adminviewflag==element.admin){
  //             this.navigationMenu.push(element)

  //            }
  //         }else{
  //           this.navigationMenu.push(element)

  //         }

  //       }

  //     });
  //     this.commondata.navigationMenu=this.navigationMenu

  //     this.commonvalues.businessid(this.commondata);
  //     //  this.commondata.selectedItem=this.navigationMenu[0]

  // }

  // submenu(data){
  //   this.submenuData=data
  // }

  ngAfterViewInit(): void {
    setInterval(() => {
      // this.isSuperAdmin = localStorage.getItem("isSuperAdmin");
      this.reqPendinCnt = localStorage.getItem("reqPendinCnt");
    }, 800);
  }

  apicall() {
    this.openSectionForUrl(this.currentRoute);
    this.util.startLoader();
    this.api.query('business/employee/request/pending/' + this.businessData.businessId).subscribe(res => {
      this.util.stopLoader();
      // this.searchData.setRequestedEmployeeCount(res.length)
      if (res.data.pendingtList != undefined && res.data.pendingtList != null)
        this.reqPendinCnt = localStorage.setItem("reqPendinCnt", res.data.pendingtList.length);

    }, err => {
      this.util.stopLoader();
    })
  }
  currentRoute: string;
  menuclick(value) {
    // Re-clicking the active menu is a same-URL navigation the router ignores —
    // reset scroll to the top and remount the tab so it reloads. Exact segment
    // match so e.g. 'employee' doesn't match '/business/employee-requests'.
    const targetPath = '/business/' + value;
    const currentPath = this.router.url.split('?')[0];
    if (currentPath === targetPath || currentPath.startsWith(targetPath + '/')) {
      // Smooth is safe here (unlike BusinessComponent's real-navigation scroll):
      // re-clicking the active tab doesn't mount any new content, so there's
      // nothing to shift the layout and cut the animation short.
      scrollBusinessToFreezePoint();
      businessTabReload$.next();
      return;
    }
    const truncatedSctring = this.router.url.slice(0, 15);
    this.commondata.menu = value;
    // if (value === "follower") {
    this.router.navigate(["/business/" + value], {
      queryParams: { currentPath: truncatedSctring },
      queryParamsHandling: 'merge',
      relativeTo: this._activated_route
    })
    // }
    // else if (value === "followerRequestsReceived") {
    //   this.router.navigate(["/business/followerRequest-received"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    //   this.businesseFollowerRequests.requestlist();
    // }
    // else if (value === "followerRequestsSent") {
    //   this.router.navigate(["/business/followerRequest-sent"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // }
    // else if (value === "employee") {
    //   this.router.navigate(["/business/employee"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // }
    // else if (value === "employee-requests") {
    //   this.router.navigate(["/business/employee-requests"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // }
    // else if (value === "pageadmin") {
    //   this.router.navigate(["/business/admin"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })

    // }
    // else if (value === "about") {
    //   this.router.navigate(["/business/about"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // }
    // else if (value === "deactivate") {
    //   this.router.navigate(["/business/deactivate"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // } else if (value === "user-management") {
    //   this.router.navigate(["/business/user-management/plan"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // } else if (value === "Jobs") {
    //   this.router.navigate(["/business/jobs"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // } else if (value === "community") {
    //   this.router.navigate(["/business/community"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // } else if (value === "post") {
    //   this.router.navigate(["/business/post"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // } else if (value === "securitySettings") {
    //   this.router.navigate(["/business/business-settings"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // } else if (value === "analytics") {

    //   this.router.navigate(["/business/analytics"], {
    //     queryParams: { currentPath: truncatedSctring },
    //     queryParamsHandling: 'merge',
    //     relativeTo: this._activated_route
    //   })
    // }
    this.widgetTrigger.emit("CLICKED");
  }
}

